export const formattedDate = (date) => {
    const anio=date.substr(0,4);
    const mes=date.substr(5,2);
    const dia=date.substr(8,2);
    return dia+'/'+mes+'/'+anio;
}